import { $api } from "../../../../../services/request.config";
import {
    setKnowledgeErrorAction,
    setKnowledgeFilesAction,
    setKnowledgeLoadingAction,
} from "../knowledgeActions";

export const getKnowledgeFilesThunk = (type) => async (dispatch) => {
    dispatch(setKnowledgeLoadingAction(true));
    try {
        const response = await $api.get(`v1/knowledge-base/categories/${type}/files`);
        if (response.status === 200) {
            dispatch(setKnowledgeFilesAction(type, response.data));
        }
    } catch (e) {
        dispatch(setKnowledgeErrorAction(e.message));
    } finally {
        dispatch(setKnowledgeLoadingAction(false));
    }
};